import { OrderLine, OrderInvoice } from '.';
import { DocumentStatus, Guid } from '@/types';

export class Order {
    public id!: string;
    public year!: number;
    public documentNumber!: number;
    public documentDate!: Date;
    public status!: DocumentStatus;
    public statusDescription!: string;
    public transmissionDate?: Date;
    public documentReference?: string;
    public lines?: OrderLine[];
    public invoices?: OrderInvoice[];

    constructor() {
        this.id = Guid.Empty;
        this.documentNumber = 0;
        this.documentDate = new Date();
        this.status = DocumentStatus.Open;
        this.statusDescription = '';
        this.lines = [];
        this.year = new Date().getFullYear();
    }
}
